import { useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 w-full items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-play-circle-fill text-xl"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950">久久视频</span>
          <span className="hidden rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800 sm:inline">
            网址导航
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#entrances"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            获取最新入口
          </a>
          <button
            type="button"
            aria-label="展开菜单"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="grid w-full grid-cols-2 gap-2 px-4 py-4 md:px-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2 text-sm text-foreground-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#entrances"
              onClick={() => setOpen(false)}
              className="col-span-2 rounded-md bg-primary-500 px-3 py-2 text-center text-sm font-medium text-background-50"
            >
              获取最新入口
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}